import { Children, Fragment } from 'react';
export function flattenFragments(children, depth = 1) {
    const flatChildren = [];
    if (Array.isArray(children)) {
        return children;
    }
    const removeFragments = (element, level = 0) => {
        var _a;
        if (!element) {
            return;
        }
        if (element.type === Fragment && level <= depth) {
            Children.toArray((_a = element.props) === null || _a === void 0 ? void 0 : _a.children).forEach((item) => {
                removeFragments(item, level + 1);
            });
        }
        else {
            flatChildren.push(element);
        }
    };
    removeFragments(children);
    return flatChildren;
}
